import { render, staticRenderFns } from "./HistoricoDeDispensa.vue?vue&type=template&id=2386a280"
import script from "./HistoricoDeDispensa.vue?vue&type=script&lang=js"
export * from "./HistoricoDeDispensa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports